export type Code = {
  id: number;
  name: string;
};

export type AreaCode = Code[];

const areaCode: AreaCode = [
  {
    id: 37,
    name: "+86",
  },
  {
    id: 32,
    name: "+1",
  },
];

// 已开通的手机区号代码
export default areaCode;
